import { Link, Stack, Typography } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { CommoditySqlView } from 'shared/types';

export function DisplayProductNumber(params: GridRenderCellParams<string, CommoditySqlView>) {
  return (
    <Stack>
      <Typography variant='body2'>
        <Link
          sx={{
            cursor: 'pointer',
          }}
        >
          {params.value as string}
        </Link>
      </Typography>
    </Stack>
  );
}
